import { Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { QueryResponse as IBoardInitResponse } from 'api/queries/getBoardInitLite.query';
import { useMobileStore } from 'store/mobile.store';
import { CardDetailsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardDetails/cardDetails.desktop';
import { CardDetailsMobile } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardDetails/cardDetails.mobile';

interface ICardDetails {
    boardInit: IBoardInitResponse | undefined;
    setValue: UseFormSetValue<IFields>;
    watch: UseFormWatch<IFields>;
    control: Control<IFields, IFields>;
    existingDetailsData?: string;
    data: CardResponse;
    queryKeys?: string[];
    register: UseFormRegister<IFields>;
    errors: FieldErrors<IFields>;
}

export const CardDetails = ({
    boardInit,
    setValue,
    watch,
    control,
    existingDetailsData,
    data,
    queryKeys = [],
    register,
    errors,
}: ICardDetails) => {
    const isMobile = useMobileStore((state) => state.isMobile);

    const handleDetails = (editorState, mentionedList) => {
        setValue('details', editorState, { shouldDirty: true });
        setValue('mentionedList', mentionedList, { shouldDirty: true });
    };

    const handleAssigneeSelect = (value) => {
        setValue('assignee', value, { shouldDirty: true });
    };

    const assigneeValue = watch('assignee');

    const submittedDurationComplete =
        data?.submittedDurationComplete &&
        (Math.round(data?.submittedDurationComplete) !== data?.submittedDurationComplete
            ? data?.submittedDurationComplete.toFixed(2)
            : data?.submittedDurationComplete);

    const tagsOptions = boardInit ? boardInit.tags.map((item) => ({ label: item.name, value: item.name })) : [];

    return !isMobile ? (
        <CardDetailsDesktop
            setValue={setValue}
            control={control}
            existingDetailsData={existingDetailsData}
            assigneeValue={assigneeValue}
            handleAssigneeSelect={handleAssigneeSelect}
            boardInit={boardInit}
            handleDetails={handleDetails}
            data={data}
            queryKeys={queryKeys}
            register={register}
            errors={errors}
            submittedDurationComplete={submittedDurationComplete}
            tagsOptions={tagsOptions}
            watch={watch}
        />
    ) : (
        <CardDetailsMobile
            setValue={setValue}
            control={control}
            existingDetailsData={existingDetailsData}
            boardInit={boardInit}
            handleDetails={handleDetails}
            data={data}
            queryKeys={queryKeys}
            register={register}
            errors={errors}
            tagsOptions={tagsOptions}
            watch={watch}
        />
    );
};
